module.exports = __webpack_public_path__ + "assets/87fc242cfdd078cdab254ae949c64674.png";